// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"style_tooltipContent__G0i9ccRtQbxPVsIViP8OV"};